import React from "react";
import styles from "assets/jss/material-dashboard-react/components/chuahoanthanh.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const Chuahoanthanh = React.memo(function Chuahoanthanh(props) {
  const classes = useStyles();
  const { idmau, thangnam } = props;
  const [data, setData] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getdata = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/DashBoard/dashctdvchuabaocao?thang=" +
      thang +
      "&maubaocao=" +
      idmau +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablenhiemvu_ct_th}>Tên đơn vị</th>
          <th className={classes.tablenhiemvu_ct_th}>Địa chỉ</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tablenhiemvu_ct_td}>{row["tendonvi"]}</td>
              <td className={classes.tablenhiemvu_ct_td}>
                {row["diachidonvi"]}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = data.length > 0 ? renderTableBody() : null;
  React.useEffect(() => {
    getdata();
  }, [idmau, thangnam]);
  return (
    <div className={classes.table_ct}>
      <table className={classes.tablenhiemvu}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Chuahoanthanh.propTypes = {
  idmau: PropTypes.number,
  thangnam: PropTypes.object,
};
export default Chuahoanthanh;
